import gql from 'graphql-tag'
import GET_VISUAL_ELEMENTS from '@/graphql/GetPodcastVisualElements.gql'

const RESPONSE_FIELDS = `
      _id
      time
      type
      label
      content {
        subtitle
        author
        lng
        url
        height
        text
        src
        title
        width
        lat
        zoom
        questions {
          id
          question
          answers {
            id
            answer
            isCorrect
          }
        }
				images {
					src
					width
					height
					text
				}
				format
      }
`

export const newId = () => `new_${Date.now()}_${Math.random()}`

export const isNew = id => id.startsWith('new_')

export const getQuery = (index, update = true) => {
  let id = ''
  let name = 'createVisualElement'
  if (update) {
    id = `  id: $id_${index},
    \t`
    name = 'updateVisualElement'
  }

  return `
    data_${index}: ${name}(
      ${id}data:  $content_${index},
    ) {${RESPONSE_FIELDS}}
  `
}

export const getVariables = (index, update = true) => {
  let id = ''
  if (update) {
    id = `$id_${index}: ID!, `
  }

  return `${id}$content_${index}: VisualElementInput!`
}

export const buildMutation = (visualElements, podcastId) => {
  const queries = []
  const variables = []
  const values = {}

  visualElements.forEach((element, index) => {
    const isUpdate = !isNew(element._id)
    queries.push(getQuery(index, isUpdate))
    variables.push(getVariables(index, isUpdate))

    if (isUpdate) {
      values[`id_${index}`] = element._id
    }

    const data = {
      time: element.time,
      type: element.type,
      label: element.label,
      content: { ...element.content },
      podcast: {
        connect: podcastId,
      },
    }

    delete data.content.__typename

    if (data.content.questions) {
      for (const question of data.content.questions) {
        delete question.__typename
        for (const answer of question.answers) {
          delete answer.__typename
        }
      }
    }

    if (data.content.images) {
      for (const image of data.content.images) {
        delete image.__typename
      }
    }

    values[`content_${index}`] = data
  })

  return {
    mutation: gql`
      mutation (${variables.join(', ')}) {
        \t${queries.join('\n')}
      }
    `,
    variables: values,
  }
}

export const readQuery = GET_VISUAL_ELEMENTS

export const updateCacheAfterSave = (store, result, id) => {
  const query = {
    query: readQuery,
    variables: { podcastId: id },
  }

  const data = store.readQuery(query)

  Object.keys(result.data).forEach(key => {
    const elementToUpdateIndex = data.findPodcastByID.visualElements.data.findIndex(
      el => el._id === result.data[key]._id,
    )
    if (elementToUpdateIndex >= 0) {
      data.findPodcastByID.visualElements.data[elementToUpdateIndex] =
        result.data[key]
    } else {
      data.findPodcastByID.visualElements.data.push(result.data[key])
    }
  })

  store.writeQuery({
    ...query,
    data,
  })

  return data
}

export const updateCacheAfterDelete = (store, result, id) => {
  const query = {
    query: readQuery,
    variables: { podcastId: id },
  }

  const data = store.readQuery(query)

  const index = data.findPodcastByID.visualElements.data.findIndex(
    p => p._id === result.data.deleteVisualElement._id,
  )

  if (index >= 0) {
    data.findPodcastByID.visualElements.data.splice(index, 1)
    store.writeQuery({
      ...query,
      data,
    })
  }
}
